
import { defineComponent, ref, reactive } from 'vue'
import { store } from '@/store'
import PrivacyPage from '@/views/pages/Privacy.vue'

export default defineComponent({
  props: {
    routeId: String
  },
  components: { PrivacyPage },
  name: 'CookieConsent',
  setup() {

    const showMore = ref(false)

    const consents = reactive({
      cookie: false,
      privacy: false
    })

    function accept() {
      store.global.acceptCookies()
    }
    
    return { accept, consents, showMore }
  }
})
